export const RETURNING_BUYER_SHIPPING_TEST_NAME = 'returning-buyer-test-q3-2023';

export const RETURNING_BUYER_SHIPPING_CONTROL_NAME = 'control';
export const RETURNING_BUYER_SHIPPING_VARIANT_NAME = 'variant';
